import {styled} from '@packages/utilities/styled';
import {getCheckboxSize} from './CheckboxStyle';

export const CheckboxLabel = styled('span')(({
  isDisabled,
  theme,
  hover,
  sizing,
  style,
}) => {
  const checkboxSize = getCheckboxSize({theme, sizing});
  return {
    color: hover ? theme.colors.foregroundVivid : theme.colors.foreground,
    fontSize:
      sizing === 'large'
        ? theme.Button.fontSize.large
        : theme.Button.fontSize.small,
    lineHeight: checkboxSize.height,
    pointerEvents: 'none',
    opacity: isDisabled ? 0.5 : 1,
    userSelect: 'none',
    whiteSpace: 'nowrap',
    ...style,
  };
});
